// extracted by mini-css-extract-plugin
export default {"headerSteps":"_4f8590a1","steps":"_ab7c23fe","step":"_cf7f530d","default":"_925a21f4","tradePrimaryColor":"_37ce0008","buyerSecondaryColor":"_2063fa21","headerStep":"_d7796352"};